import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import React from 'react';
const meetingCardContainerIsPhoneCss = "m1ej3iod";
const meetingCardContainerIsFirstCss = "mzwgzw1";
const meetingCardContainerIsLastCss = "m1y7rr4t";
const meetingCardContainerCss = "m1soa9x6";
interface MeetingCardContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  isFirst?: boolean;
  isLast?: boolean;
}

/**
 * Wrapper div for a meeting card that handles border, border-radius, and stacking.
 *
 * Applies rounded corners to the first and last cards in a group, removes the
 * bottom border on the last card, and sets a `z-index` on phone to ensure
 * correct stacking. Accepts all standard `div` HTML attributes via rest props.
 *
 * @param isFirst - Whether this is the first card in the group (rounds top corners)
 * @param isLast - Whether this is the last card in the group (rounds bottom corners, removes bottom border)
 * @param className - Optional additional CSS class
 */
export const MeetingCardContainer: React.FC<MeetingCardContainerProps> = ({
  isFirst,
  isLast,
  className,
  ...restProps
}) => {
  const isPhone = useDeviceType('isPhone');
  return <div {...restProps} className={classNames(meetingCardContainerCss, {
    [meetingCardContainerIsPhoneCss]: isPhone,
    [meetingCardContainerIsFirstCss]: isFirst,
    [meetingCardContainerIsLastCss]: isLast
  }, className)} />;
};

require("./MeetingCardContainer.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MeetingCardContainer.tsx");